module.exports = __webpack_public_path__ + "img/U6.f4634c00.png";